import { jsxs as i, jsx as o } from "react/jsx-runtime";
import { WelcomeMessage as t } from "../WelcomeMessage/index.js";
import { palette as r } from "../../utils/theme.js";
import e from "@mui/joy/Button";
import n from "@mui/joy/Stack";
import c from "./circle-icon.svg.js";
import { ERROR_MESSAGES as m } from "./utils.js";
const s = ({ hideButton: s2, title: l = m.UNKNOWN.title, description: a = m.UNKNOWN.description, onActionClick: d = () => window.location.reload() }) => i(n, { sx: { height: "100vh" }, justifyContent: "center", alignItems: "center", gap: 4, children: [o(t, { width: "500px", icon: o(c, {}), hideTitleEndDecorator: true, title: l, description: a }), !s2 && o(e, { size: "sm", onClick: d, sx: { backgroundColor: r.primary[500], "&:hover, &:active": { backgroundColor: r.primary[700] } }, children: "Перезавантажити" })] });
export {
  s as ErrorView,
  s as default
};
//# sourceMappingURL=ErrorView.js.map
